import { AnalyticsParams } from "../analyticsClient";

export function compactAnalyticsParams(params: AnalyticsParams): AnalyticsParams {
  const compacted: AnalyticsParams = {};

  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) {
      continue;
    }

    if (typeof value === "string" && value.trim().length === 0) {
      continue;
    }

    compacted[key] = value;
  }

  return compacted;
}

export function computeDurationMs(
  startedAtMs: number,
  endedAtMs = Date.now(),
): number {
  return Math.max(0, endedAtMs - startedAtMs);
}
